import createLucideIcon from '../createLucideIcon';

const FilterX = createLucideIcon('FilterX', [
  [
    'path',
    {
      d: 'm13.013 3h-11.013l8 9.46v6.54l4 2v-8.54l0.89973-1.0554',
      key: 'n7hfgz',
    },
  ],
  ['path', { d: 'm22 3-5 5', key: '12jva0' }],
  ['path', { d: 'm17 3 5 5', key: 'k36vhe' }],
]);

export default FilterX;
